import React, { useEffect, useState } from "react";
import { FaMap } from "react-icons/fa";
import "./MapControls.css";
import { getTranslation } from "../../utils/translations";

// أيقونة القمر الصناعي المحدثة من مجلد v3
const SatelliteIcon = () => (
  <img
    src="/map_controls/Settilite v2.png"
    alt="Satellite"
    className="satellite-icon control-icon-img"
  />
);



const MapControls = ({
  mapStyle,
  onMapStyleChange,
  onLanguageToggle,
  language,
  mapRef,
  isUnitDetailsVisible = false,
  isProjectDetailsVisible = false,
  onSubHomeClick,
  onHomeClick,
  isSharedView = false,
  currentZoom = 6,
}) => {
  // Local UI state to control visibility of Sub Home button
  const [showSubHome, setShowSubHome] = useState(!!isUnitDetailsVisible);

  // Keep local state in sync with props (unit details OR project details) and zoom level
  useEffect(() => {
    // Hide Sub Home button if zoom is 8 or less, regardless of other conditions
    if (currentZoom <= 8) {
      setShowSubHome(false);
    } else {
      setShowSubHome(!!isUnitDetailsVisible || !!isProjectDetailsVisible);
    }
  }, [isUnitDetailsVisible, isProjectDetailsVisible, currentZoom]);

  const mapStyles = [
    {
      id: "satellite-v9",
      name: getTranslation("satellite", language),
      icon: <SatelliteIcon />,
    },
    {
      id: "satellite-streets-v12",
      name: getTranslation("satellite", language) + " +",
      icon: <SatelliteIcon />,
    },
    {
      id: "streets-v11",
      name: getTranslation("streets", language),
      icon: <FaMap />,
    },
  ];

  const currentStyleIndex = mapStyles.findIndex(
    (style) => style.id === mapStyle
  );

  const handleMapStyleToggle = () => {
    const nextIndex = (currentStyleIndex + 1) % mapStyles.length;
    const newStyle = mapStyles[nextIndex].id;
    onMapStyleChange(newStyle);
  };



  return (
    <div className="map-controls">
      {/* Map Style Toggle Button */}


      {/* Language Toggle Button */}
      <button
        className="control-btn language-toggle segment-vertical"
        onClick={onLanguageToggle}
        title={getTranslation("changeLanguage", language)}
      >
        <div className="language-segment">
          <span className="language-text current">{language === 'ar' ? 'ع' : 'E'}</span>
          <div className="language-divider"></div>
          <span className="language-text next">{language === 'ar' ? 'En' : 'ع'}</span>
        </div>
      </button>



       <button
        className="control-btn map-style-toggle"
        onClick={() => {
          handleMapStyleToggle();
        }}
        title={getTranslation("changeMapStyle", language)}
      >
        <span className="control-icon">
          {mapStyles[currentStyleIndex]?.icon || <FaMap />}
        </span>
      </button>
      {/* Zoom Controls */}
      {/* <div className="zoom-controls">
        <button
          className="control-btn zoom-btn zoom-in"
          onClick={() => mapRef?.current?.zoomIn()}
          title={getTranslation("zoomIn", language)}
        >
          <span className="control-icon">
            <FaPlus />
          </span>
        </button>
        <button
          className="control-btn zoom-btn zoom-out"
          onClick={() => mapRef?.current?.zoomOut()}
          title={getTranslation("zoomOut", language)}
        >
          <span className="control-icon">
            <FaMinus />
          </span>
        </button>
      </div> */}
      {/* Home Button - Hidden in shared view */}
      {!isSharedView && (
        <button
          className="control-btn reset-view"
          onClick={() => {
            // Default home functionality
            if (mapRef?.current) {
              mapRef.current.flyTo({
                center: [45.0792, 23.8859], // Saudi Arabia center
                zoom: 6,
              });
            }

            // Hide Sub Home button when Home is pressed
            setShowSubHome(false);
            if (onHomeClick) {
              onHomeClick();
            }
          }}
          title={getTranslation("resetView", language)}
        >
          <span className="control-icon">
            <img
              src="/map_controls/emerging-industries white white.png"
              alt="Home"
              className="control-icon-img"
            />
          </span>
        </button>
      )}
      {/* Reset View Button / Sub Home Button */}
      <button
      //visable
      style={{  visibility: showSubHome ? 'visible' : 'hidden' }}

        className="control-btn reset-view"
        onClick={() => {
          if ((isUnitDetailsVisible || isProjectDetailsVisible) && onSubHomeClick) {
            // If unit details are visible, use sub home functionality
            onSubHomeClick();
          } else {
            // Default home functionality
            if (mapRef?.current) {
              mapRef.current.flyTo({
                center: [45.0792, 23.8859], // Saudi Arabia center
                zoom: 6,
              });
            }
          }
        }}
        title={showSubHome ?
          (language === "ar" ? "عرض تفاصيل المشروع" : "Show Project Details") :
          getTranslation("resetView", language)
        }
      >
        <span className="control-icon">
          <img
            src={showSubHome ? "/map_controls/home white white v2.png" : "/map_controls/home white white v2.png"}
            alt={showSubHome ? "Sub Home" : "Home"} 
            className="control-icon-img"
          />
        </span>
      </button>

    </div>
  );
};

export default MapControls;
